import {useState, forwardRef} from 'react';
import {InputField, InputFieldProps} from './Input';

export const SearchInput = forwardRef<HTMLInputElement, InputFieldProps>(
  ({...props}, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <InputField
        {...props}
        ref={ref}
        rightSlot={
          isFocused ? (
            <img src='/assets/images/icn-search-select.svg' alt='search-icon' />
          ) : (
            <img
              src='/assets/images/icn-search-disabled.svg'
              alt='search-icon'
            />
          )
        }
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    );
  },
);

SearchInput.displayName = 'SearchInput';
